import {settings} from "../../../../settings/settings-util";
import {propStore} from "../util";

export default function toggleHeaderButtonsToState(passedSettings: typeof settings, disabled: boolean): void
{
    const className = passedSettings.classNames.headerClassName;
    const links = document.querySelectorAll(`.${className} a`);
    const buttons = document.querySelectorAll(`.${className} button`);

    Array.from(links).forEach(link =>
    {
        if (disabled)
        {
            link.className = settings.classNames.headerButtonDisabled;
            propStore.backup(link);
        }
        else
        {
            link.className = '';
            propStore.restore(link);
        }
    });

    Array.from(buttons).forEach(element =>
    {
        if (disabled)
        {
            (element as HTMLElement).setAttribute('disabled', 'true');
        }
        else
        {
            (element as HTMLElement).removeAttribute('disabled');
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/headerButtons.ts